<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>菜单设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col :span="12">
          <el-popconfirm
            title="新建菜单或目录？"
            cancel-button-type="primary"
            cancel-button-text="菜单"
            confirm-button-text="按钮"
            @cancel="showAddMenu"
            @confirm="clickAddBtnClick"
          >
            <el-button slot="reference">新增</el-button>
          </el-popconfirm>
        </el-col>
      </el-row>

      <!-- 表格树 -->
      <tree-table
        class="treeTable"
        index-text="No."
        show-index
        :data="menuList"
        :columns="columns"
        :expand-type="false"
        :selection-type="false"
        border
      >
        <template #permission="scope">
          <el-tag v-if="scope.row.permission">{{scope.row.permission}}</el-tag>
        </template>
        <template #menuType="scope">
          <el-tag type="success" v-if="scope.row.menuType == '0'">按钮</el-tag>
          <el-tag type="warning" v-if="scope.row.menuType == '1'">目录</el-tag>
          <el-tag type="warning" v-if="scope.row.menuType == '2'">系统菜单</el-tag>
        </template>
        <template #opt="scope">
          <div class="btnList">
            <el-button size="mini" icon="el-icon-edit" @click="editMenu(scope.row)"></el-button>
            <el-popconfirm title="点击确定删除该节点内容，如果有子节点，需先删除子节点" @confirm="deleteMenuList(scope.row)">
              <el-button size="mini" class="deleteBtn" icon="el-icon-delete" slot="reference"></el-button>
            </el-popconfirm>
          </div>
        </template>
      </tree-table>
    </el-card>

    <!-- 添加按钮抽屉 -->
    <el-drawer :title="title" :visible.sync="btnDrawer" direction="rtl" @close="btnDrawerClosed"  :wrapperClosable="false">
      <el-form :model="addMenuForm" :rules="addMenuRules" ref="buttonFormRef" label-width="100px">
        <el-form-item label="按钮名称:" prop="menuName">
          <el-input v-model="addMenuForm.menuName"></el-input>
        </el-form-item>
        <el-form-item label="相关权限" prop="permission">
          <el-input v-model="addMenuForm.permission"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="addMenuForm.status">
            <el-radio label="Y">生效</el-radio>
            <el-radio label="N">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级菜单" prop="treeData">
          <el-tree
            :check-strictly="true"
            :data="treeData"
            :show-checkbox="true"
            node-key="id"
            :default-expanded-keys="[defaultCheckedKeys]"
            :default-checked-keys="[defaultCheckedKeys]"
            :props="defaultProps"
            ref="checkedIdTree"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div class="drawer-bootom">
        <el-button type="primary" @click="btnDrawerClosed">取消</el-button>
        <el-button type="primary" @click="menuHandler">提交</el-button>
      </div>
    </el-drawer>

    <!-- 编辑菜单抽屉 -->
    <el-drawer :title="title" :visible.sync="menuDrawer" @close="menuDrawerClosed" direction="rtl" :wrapperClosable="false">
      <el-form
        class="menuForm"
        :model="addMenuForm"
        :rules="addMenuRules"
        ref="menuFormRef"
        label-width="100px"
      >
        <el-form-item v-if="this.addMenuForm.menuType !== '0'" label="菜单类型" prop="menuType">
          <el-radio-group v-model="addMenuForm.menuType">
            <el-radio label="1">目录</el-radio>
            <el-radio label="2">菜单</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="this.addMenuForm.menuType=='0'" label="按钮名称:" prop="menuName">
          <el-input v-model="addMenuForm.menuName"></el-input>
        </el-form-item>
        <el-form-item v-else label="菜单名称:" prop="menuName">
          <el-input v-model="addMenuForm.menuName"></el-input>
        </el-form-item>

        <div v-if="this.addMenuForm.menuType!=='0'">
          <el-form-item label="菜单URL:" prop="path">
            <el-input v-model="addMenuForm.path"></el-input>
          </el-form-item>
          <el-form-item label="组件地址" prop="component">
            <el-input v-model="addMenuForm.component"></el-input>
          </el-form-item>

          <el-form-item label="菜单图标" prop="icon">
            <el-input v-model="addMenuForm.icon"></el-input>
          </el-form-item>
          <el-form-item label="菜单排序" prop="sortNo">
            <el-input placeholder="排序(数字)" v-model="addMenuForm.sortNo"></el-input>
          </el-form-item>
          <el-form-item label="特殊标识" prop="specialCode">
            <el-input v-model="addMenuForm.specialCode"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="相关权限" prop="permission">
          <el-input v-model="addMenuForm.permission"></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="addMenuForm.status">
            <el-radio label="Y">生效</el-radio>
            <el-radio label="N">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级菜单" prop="treeData">
          <el-tree
            :check-strictly="true"
            :data="treeData"
            :show-checkbox="true"
            node-key="id"
            :default-expanded-keys="[defaultCheckedKeys]"
            :default-checked-keys="[defaultCheckedKeys]"
            :props="defaultProps"
            ref="checkedIdTree"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div class="drawer-bootom">
        <!-- <el-popconfirm title="确定放弃编辑？" @confirm="menuDrawer = false">
          <el-button slot="reference">取消</el-button>
        </el-popconfirm>-->
        <el-button type="primary" @click="menuDrawerClosed">取消</el-button>
        <el-button type="primary" @click="menuHandler">提交</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 菜单列表
      menuList: [],
      // 菜单树 列表项
      columns: [
        {
          label: '名称',
          prop: 'menuName',
          minWidth: '150px',
        },
        {
          label: '图标',
          // 表示将当前列定义为模板列
          prop: 'icon',
        },
        {
          label: '类型',
          // 表示将当前列定义为模板列
          type: 'template',
          // 表示当前这一列使用的模板名称
          template: 'menuType',
        },
        {
          label: '地址',
          // 表示将当前列定义为模板列
          prop: 'path',
        },
        {
          label: 'Vue组件',
          // 表示将当前列定义为模板列
          prop: 'component',
        },
        {
          label: '权限',
          // 表示将当前列定义为模板列
          type: 'template',
          // 表示当前这一列使用的模板名称
          template: 'permission',
        },
        {
          label: '排序',
          prop: 'sortNo',
        },
        {
          label: '修改时间',
          // 表示将当前列定义为模板列
          prop: 'updatedTime',
        },
        {
          label: '操作',
          // 表示将当前列定义为模板列
          type: 'template',
          // 表示当前这一列使用的模板名称
          template: 'opt',
        },
      ],
      // 分页器总页数
      total: 0,

      // 增加菜单抽屉显示与隐藏
      menuDrawer: false,
      addMenuForm: {
        status: 'Y',
      },
      title: '',
      addMenuRules: {
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'change' },
        ],
        menuName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 2,
            max: 100,
            message: '长度在 2 到 100 个字符',
            trigger: 'blur',
          },
        ],
        path: [{ required: true, message: '请输入菜单URL', trigger: 'blur' }],
      },
      // 新增菜单节点树
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },

      // 取消增加菜单弹框
      cancleAddMenuvisible: false,

      // 编辑菜单抽屉的显示与隐藏
      menuDrawer: false,

      // 编辑菜单选中的节点
      defaultCheckedKeys: [],
      // 编辑菜单选中的节点的父级节点
      defaultCheckedParentId: [],

      // 添加按钮抽屉的显示与隐藏
      btnDrawer: false,
    }
  },
  methods: {
    showAddMenu() {
      this.menuDrawer = true
      this.title = '新增菜单'
      this.addMenuForm = { status: 'Y', menuType: '2' }
    },
    editMenu(info) {
      // 先查询最新的菜单信息，再进行删除
      this.$get(`permission/get/${info.id}`).then(({ data: res }) => {
        this.addMenuForm = res.data

        this.defaultCheckedKeys = this.addMenuForm.parentId
        this.defaultCheckedParentId = this.addMenuForm.parentId
        console.log('parentid', this.addMenuForm.parentId)
        console.log('defaultCheckedKeys', this.defaultCheckedKeys)
        console.log('defaultCheckedParentId', this.defaultCheckedParentId)
      })
      if (info.menuType == 0) {
        //编辑按钮
        this.title = '编辑按钮'
        this.btnDrawer = true
      } else {
        //编辑目录，菜单
        this.title = '编辑菜单'
        this.menuDrawer = true
      }

      // var arr = [1, 2]
      // this.$get(`permission/getMenuTree?menuType=${arr.join(',')}`).then(
      //   ({ data: res }) => {
      //     this.treeData = res.data
      //   }
      // )
    },
    // 点击添加或编辑     菜单或按钮
    menuHandler() {
      let refName
      // 通过menuType来判断 操作按钮还是操作菜单 的请求
      if (this.addMenuForm.menuType == 0) {
        refName = 'buttonFormRef'
      } else {
        refName = 'menuFormRef'
      }

      this.$refs[refName].validate(async (valid) => {
        if (!valid) return
        // 选中的节点数组
        let checkedArr = this.$refs.checkedIdTree.getCheckedNodes(false, true)
        if (checkedArr == null || checkedArr.length <= 0) {
          this.$message.error({
            message: '必须选择一个上级',
            center: true,
          })
          return
        }

        if (checkedArr.length > 1) {
          this.$message.error({
            message: '只能选择一个节点进行操作',
            center: true,
          })
          return
        } else {
          // 最外层父节点
          this.addMenuForm.parentId = checkedArr[0].id
          console.log(this.addMenuForm)
          this.$post(`permission/save`, this.addMenuForm).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error('操作失败')
              }
              this.$message.success('操作成功')
              // 刷新列表
              this.getMenuList()
              if (this.addMenuForm.menuType == 0) {
                this.btnDrawerClosed()
              } else {
                this.menuDrawerClosed()
              }

              // this.btnDrawer = false
              // this.menuDrawer = false
              // this.menuDrawer = false
              // 关闭抽屉置空，便于下次判断
              // this.defaultCheckedPrentId = ''
              // this.defaultCheckedKeys = ''
              // this.addMenuForm.id = ''
            }
          )
        }
      })
    },

    menuDrawerClosed() {
      this.addMenuForm = { status: 'Y', menuType: 2 }
      this.menuDrawer = false
      this.defaultCheckedKeys = []
      this.defaultCheckedParentId = []
      this.$refs.menuFormRef.resetFields()
    },
    btnDrawerClosed() {
      this.addMenuForm = { status: 'Y', menuType: 0 }
      this.btnDrawer = false
      this.defaultCheckedKeys = []
      this.defaultCheckedParentId = []
      this.$refs.buttonFormRef.resetFields()
    },

    // 删除菜单按钮
    deleteMenuList(info) {
      if (info.children.length > 0) {
        return this.$message.error({
          message: '该节点下含有子节点，删除失败',
          center: true,
        })
      }
      this.$get(`permission/batchDelete?idList=${info.id}`).then(
        ({ data: res }) => {
          console.log(res)
          if (res.code !== 200) {
            return this.$message.error({
              message: '删除失败',
              center: true,
            })
          }
          this.$message.success({
            message: '删除成功',
            center: true,
          })
          this.getMenuList()
          return
        }
      )
    },

    // 添加按钮
    clickAddBtnClick() {
      console.log('打开添加按钮弹窗')
      this.btnDrawer = true
      // 添加按钮  menuType = 0
      this.addMenuForm.menuType = 0
      this.addMenuForm.status = 'Y'
      var arr = [1, 2]
      this.$get(`permission/getMenuTree?menuType=${arr.join(',')}`).then(
        ({ data: res }) => {
          this.treeData = res.data
        }
      )
    },
    // 获取 查询用户数据列表
    getMenuList() {
      this.$post(`permission/menu`, {}).then(({ data: res }) => {
        this.menuList = res.data
      })
    },
  },
  created() {
    this.getMenuList()
  },
  watch: {
    menuDrawer(newVal, oldVal) {
      if (newVal) {
        // 0 按钮 1 目录 2 菜单
        var arr = [1, 2]
        this.$get(`permission/getMenuTree?menuType=${arr.join(',')}`).then(
          ({ data: res }) => {
            this.treeData = res.data
          }
        )
      }
    },
    btnDrawer(newVal, oldVal) {
      if (newVal) {
        // 0 按钮 1 目录 2 菜单
        var arr = [1, 2]
        this.$get(`permission/getMenuTree?menuType=${arr.join(',')}`).then(
          ({ data: res }) => {
            this.treeData = res.data
          }
        )
      }
    },
  },
}
</script>

<style lang="less" scoped>
.rightContent {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}

.treeTable {
  margin-top: 20px;
}

.el-tag {
  margin-right: 10px;
  border: none;
}
.btnList {
  display: flex;
  justify-content: space-around;
}

.deleteBtn {
  margin: 0;
}

.menuForm {
  padding-right: 30px;
  padding-bottom: 20px;
  overflow-y: scroll;
}
/deep/.el-drawer__body {
  height: auto;
  overflow: scroll;
}
.drawer-bootom {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background-color: #fff;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  .el-button {
    margin-right: 15px;
  }
}
</style>